import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { accordionAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle = definePartsStyle({
  button: {
    textAlign: 'left',
  },
});

const allcaps = definePartsStyle({
  button: {
    letterSpacing: 'wider',
    textTransform: 'uppercase',
    fontWeight: '500',
    fontSize: 'xs',
    lineHeight: '1rem',
    py: 2.5,
  },
});

const rounded = definePartsStyle({
  container: {
    bgColor: 'gray.50',
    borderRadius: 'lg',
    borderWidth: 0,
    mb: 2,
    p: 1,

    _dark: {
      bgColor: 'whiteAlpha.100',
    },

    _last: {
      borderBottomWidth: 0,
      mb: 0,
    },
  },

  button: {
    alignItems: 'start',
    borderRadius: 'base',
    textAlign: 'left',
    py: 3,
    pl: 7,
    position: 'relative',
    letterSpacing: 'wider',
    textTransform: 'uppercase',
    fontWeight: '500',
    fontSize: 'xs',
    lineHeight: '1rem',

    _hover: {
      bgColor: 'utility.100',

      _dark: {
        bgColor: 'whiteAlpha.50',
      },
    },
  },

  icon: {
    position: 'absolute',
    left: 2,
    top: '2.5',
    fontSize: '1.375em',
  },

  panel: {
    borderRadius: 'base',
    p: 0,
  },
});

export const accordionTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  variants: {
    rounded,
    allcaps,
  },
});
